
export const IMAGE_SIZES = {
  S_1280: 1280,
  S_716: 716,
  S_640: 640,
  S_420: 420,
  S_358: 358,
  S_280: 280,
  S_268: 268,
  S_238: 238,
  S_200: 200,
  S_180: 180,
  S_172: 172,
  S_150: 150,
  S_140: 140,
  S_136: 136,
  S_100: 100,
  S_90: 90,
  S_75: 75,
  S_68: 68,
  S_64: 64,
  S_55: 55,
};

import noImage from 'themes/[theme]/assets/images/noImage140.jpg';

export function getProductImageUrl(productSku, image, size) {
  if (image) {
    const { sku = productSku, position = 0, hash } = image;
    return `/productImages/${sku.slice(0, 3)}/${sku}_${position}_${size}x${size}.jpg?identifier=${hash}`;
  }
  return noImage;
}
